import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from "react";
import { cn } from "@/lib/cn";

type Props = Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children"> & {
	label: string;
	children: ReactNode;
};

export const IconButton = forwardRef<HTMLButtonElement, Props>(
	function IconButton(
		{ label, children, className, type = "button", ...rest },
		ref,
	) {
		return (
			<button
				ref={ref}
				type={type}
				aria-label={label}
				title={label}
				className={cn(
					"relative inline-flex size-8 shrink-0 items-center justify-center",
					"rounded-[var(--radius-control)] text-fg-muted",
					"hover:bg-zinc-950/[0.06] hover:text-fg dark:hover:bg-white/10",
					"focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-500",
					"disabled:pointer-events-none disabled:opacity-40",
					className,
				)}
				{...rest}
			>
				{children}
				<span
					className="pointer-events-none absolute top-1/2 left-1/2 size-[max(100%,3rem)] -translate-x-1/2 -translate-y-1/2 pointer-fine:hidden"
					aria-hidden="true"
				/>
			</button>
		);
	},
);
